import { render, staticRenderFns } from "./HeaderListaBarredores.vue?vue&type=template&id=56f1c0d4&scoped=true&"
import script from "./HeaderListaBarredores.vue?vue&type=script&lang=ts&"
export * from "./HeaderListaBarredores.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderListaBarredores.vue?vue&type=style&index=0&id=56f1c0d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1c0d4",
  null
  
)

export default component.exports